import { BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AssignmentFilterService {

  private initialFilterValue = {
    selectedFilter: "needsAttention", 
    moreOptions: false,
    allComplete: false,
    needsAttentionFilter: {
      name: "Select All",
      checked: false,
      subFilters: [
        {
          name: "Not started",
          checked: false
        },
        {
          name: "In Progress",
          checked: false
        },
        {
          name: "Needs Grade",
          checked: false
        },
        {
          name: "Needs Grade Released",
          checked: false
        },
        {
          name: "Needs Answer Key Released",
          checked: false
        },
        {
          name: "Completed",
          checked: false
        }
      ]
    }
  }

  private filterValue = new BehaviorSubject<any>(this.initialFilterValue);
  currentFilterValue = this.filterValue.asObservable();

  private needsAttentionOnly: boolean = true;

  constructor() { }

  setFilterValue = (filterValue) => {
    if(filterValue.selectedFilter == 'common')
    {
      this.needsAttentionOnly = false;
    } else {
      this.needsAttentionOnly = true;
    }
    this.filterValue.next(filterValue);
  }

  getFilterValue = () => {
    return this.filterValue.value;
  }

  private needsAttentionStatus = (data) => {
    if(data.NeedsAttention) {
      return true;
    }
    return false;
  }

  private notStartedStatus = (data) => {
    if(data.AttemptCount === 0) {
      return true;
    }
    return false;
  }

  private inProgressStatus = (data) => {
    if(!data.SubmittedAsComplete && data.AttemptCount > 0) {
      return true;
    }
    return false;
  }

  private needsGradeStatus = (data) => {
    if(data.SubmittedAsComplete && !data.Graded) {
      return true;
    }
    return false;
  }

  private needsGradeReleasedStatus = (data) => {
    if(data.Graded && data.SubmittedAsComplete && !data.GradeReleased) {
      return true;
    }
    return false;
  }

  private needsAnswerKeyReleasedStatus = (data) => {
    if(!data.AnswerKeyReleased && data.SubmittedAsComplete) {
      return true;
    }
    return false;
  }

  private completedStatus = (data) => {
    if(!data.NeedsAttention) {
      return true;
    }
    return false;
  }

  showData = (data) => {
    let filterValue = this.filterValue.value;

    if(filterValue.selectedFilter === 'needsAttention' && this.needsAttentionOnly) {
      return this.needsAttentionStatus(data);
    }

    if(filterValue.selectedFilter === 'common' && filterValue.needsAttentionFilter.subFilters.filter(f => f.checked).length == 0){
      return true;
    }

    if(filterValue.needsAttentionFilter.subFilters[0].checked) {
      if (this.notStartedStatus(data)) return true;
    }

    if(filterValue.needsAttentionFilter.subFilters[1].checked) {
      if (this.inProgressStatus(data)) return true;
    }

    if(filterValue.needsAttentionFilter.subFilters[2].checked) {
      if (this.needsGradeStatus(data)) return true;
    }

    if(filterValue.needsAttentionFilter.subFilters[3].checked) {
      if (this.needsGradeReleasedStatus(data)) return true;
    }

    if(filterValue.needsAttentionFilter.subFilters[4].checked) {
      if (this.needsAnswerKeyReleasedStatus(data)) return true;
    }

    if(filterValue.needsAttentionFilter.subFilters[5].checked) {
      if (this.completedStatus(data)) return true;
    }

    return false;
  }
}
